import config from 'config';

export type ReportVariant = 'menopause' | 'peak-performance';

const REPORT_VARIANT_CSS: Record<ReportVariant, string[]> = {
  menopause: ['reports-base.css'],
  'peak-performance': ['reports-base.css', 'reports-peak-performance.css'],
};

const PROMPT_TO_VARIANT: Record<string, ReportVariant> = {
  'Menopause - Executive Report': 'menopause',
  'Peak Performance - Executive Report': 'peak-performance',
};

const VARIANT_REGEX = /<div\s+class="container\s+([a-z0-9-]+)(?:\s+[^"]*)?"/i;

function isReportVariant(value: string): value is ReportVariant {
  return value in REPORT_VARIANT_CSS;
}

export function variantFromPromptName(promptName: string): ReportVariant | null {
  return PROMPT_TO_VARIANT[promptName] ?? null;
}

export function detectReportVariant(html: string): ReportVariant | null {
  const candidate = html.match(VARIANT_REGEX)?.[1];
  return candidate && isReportVariant(candidate) ? candidate : null;
}

export async function fetchReportCss(variant: ReportVariant | null): Promise<string> {
  const { PROTOCOL, API_URL } = config as any;
  const files = (variant && REPORT_VARIANT_CSS[variant]) || ['reports-base.css'];
  const parts = await Promise.all(
    files.map((file) =>
      fetch(`${PROTOCOL}://${API_URL}/static/reports/${file}`)
        .then((res) => (res.ok ? res.text() : ''))
        .catch(() => ''),
    ),
  );
  return parts.join('\n');
}
